export const ROUTES = {
  HOME: '/',
  COURSES: '/courses',
  COURSE_ABOUT: '/courses/:courseId/about',
  NOT_FOUND: '*',
} as const;
